import { render, staticRenderFns } from "./flickity.vue?vue&type=template&id=2af8bc48&"
import script from "./flickity.vue?vue&type=script&lang=js&"
export * from "./flickity.vue?vue&type=script&lang=js&"
import style0 from "flickity/dist/flickity.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af8bc48')) {
      api.createRecord('2af8bc48', component.options)
    } else {
      api.reload('2af8bc48', component.options)
    }
    module.hot.accept("./flickity.vue?vue&type=template&id=2af8bc48&", function () {
      api.rerender('2af8bc48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-flickity/src/flickity.vue"
export default component.exports